export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILED = 'GET_USERS_FAILED';
export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILED = 'GET_USER_FAILED';
export const ADD_USER_REQUEST = 'ADD_USER_REQUEST';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_FAILED = 'ADD_USER_FAILED';
export const INVITE_USER_REQUEST = 'INVITE_USER_REQUEST';
export const INVITE_USER_SUCCESS = 'INVITE_USER_SUCCESS';
export const INVITE_USER_FAILED = 'INVITE_USER_FAILED';
export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILED = 'UPDATE_USER_FAILED';
export const CHANGE_ACTIVE_STATUS_USER_REQUEST = 'CHANGE_ACTIVE_STATUS_USER_REQUEST';
export const CHANGE_ACTIVE_STATUS_USER_SUCCESS = 'CHANGE_ACTIVE_STATUS_USER_SUCCESS';
export const CHANGE_ACTIVE_STATUS_USER_FAILED = 'CHANGE_ACTIVE_STATUS_USER_FAILED';
export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILED = 'DELETE_USER_FAILED';
export const MAKE_ADMIN_REQUEST = 'MAKE_ADMIN_REQUEST';
export const MAKE_ADMIN_SUCCESS = 'MAKE_ADMIN_SUCCESS';
export const MAKE_ADMIN_FAILED = 'MAKE_ADMIN_FAILED';
export const REVERT_ADMIN_REQUEST = 'REVERT_ADMIN_REQUEST';
export const REVERT_ADMIN_SUCCESS = 'REVERT_ADMIN_SUCCESS';
export const REVERT_ADMIN_FAILED = 'REVERT_ADMIN_FAILED';
export const UPDATE_ATTRIBUTES_REQUEST = 'UPDATE_ATTRIBUTES_REQUEST';
export const UPDATE_ATTRIBUTES_SUCCESS = 'UPDATE_ATTRIBUTES_SUCCESS';
export const UPDATE_ATTRIBUTES_FAILED = 'UPDATE_ATTRIBUTES_FAILED';
export const ADD_ADMIN_PERMISSIONS_SUCCESS = 'ADD_ADMIN_PERMISSIONS_SUCCESS';
export const ADD_CUSTOM_ATTRIBUTES_SUCCESS = 'ADD_CUSTOM_ATTRIBUTES_SUCCESS';
export const UPDATE_OWN_ATTRIBUTE = 'UPDATE_OWN_ATTRIBUTE';
export const USER_MANAGEMENT_UPDATE_USER_IMAGE = 'USER_MANAGEMENT_UPDATE_USER_IMAGE';
export const RESET_USERS = 'RESET_USERS';
export const MAKE_INVITE_ALL_REQUEST = 'MAKE_INVITE_ALL_REQUEST';
export const MAKE_INVITE_ALL_SUCCESS = 'MAKE_INVITE_ALL_SUCCESS';
export const MAKE_INVITE_ALL_FAILED = 'MAKE_INVITE_ALL_FAILED';
